import type { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

export interface StoreDmGate {
  /** The id has a store doc → it's a creator (the DM peer that can gate). */
  isCreator: boolean;
  /** The creator's CURRENT DM floor; undefined = "any subscriber". */
  minLevel: PopStoreExtendedSubscriptionLevel | undefined;
}

/**
 * One-shot live read of `stores/<id>` for the DM send gate — creator detection +
 * the CURRENT `dmMinimumSubscriptionLevel`, NOT the ISR-cached bio value (which
 * is stale right after a creator changes it). Mirrors PopshopRN's
 * `storeFront$(creatorId)` read in `ChatActionBar.checkChatCapability`.
 *
 * `firebase/firestore` is dynamic-imported so it stays out of the visitor bundle
 * for anyone who never opens a chat.
 */
export async function fetchStoreDmGate(storeId: string): Promise<StoreDmGate> {
  const { doc, firestore, getDoc } =
    await import('@ps/functions/firebase/firestore');
  const snap = await getDoc(doc(firestore(), 'stores', storeId));
  if (!snap.exists()) {
    return { isCreator: false, minLevel: undefined };
  }
  return {
    isCreator: true,
    minLevel: snap.data()?.dmMinimumSubscriptionLevel as
      | PopStoreExtendedSubscriptionLevel
      | undefined,
  };
}
